import { $, $$ } from 'utils/dom';
import Slider from 'modules/glide/glide';

const scrollToSlide = (
  target,
  to = 0,
  duration = 1000,
  scrollToDone = null
) => {
  Math.easeInOutQuad = (time, begin, change, dur) => {
    let t = time;
    const b = begin;
    const c = change;
    const d = dur;

    t /= d / 2;
    // eslint-disable-next-line no-mixed-operators
    if (t < 1) return (c / 2) * t * t + b;
    t -= 1;
    // eslint-disable-next-line no-mixed-operators
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  const start = target.scrollTop;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;

  const animateScroll = () => {
    currentTime += increment;

    target.scrollTop = Math.easeInOutQuad(currentTime, start, change, duration);

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    } else if (scrollToDone) scrollToDone();
  };

  animateScroll();
};

const gridSliders = $$('.teaser-slider');
if (gridSliders.length) {
  gridSliders.forEach(gridSlider => {
    const listContainer = $('.teaser-slider__list', gridSlider);
    const teaserButton = $('.teaser-slider__button', gridSlider);
    const teaserSliderItems = $$('.teaser-slider__item', gridSlider);
    const slider = new Slider($('.glide', gridSlider), {
      config: {
        type: 'slider',
        startAt: 0,
        perView: 1,
        controls: true,
        bound: true,
        gap: 45,
      },
    });

    let isActive = false;

    if (window.innerWidth <= 1199 && teaserSliderItems.length > 1) {
      slider.init();
      isActive = true;
    }

    const activeIndex = 0;

    listContainer.scrollTop = 0;
    teaserSliderItems[activeIndex].classList.add('active-item');

    if (teaserButton) {
      teaserButton.addEventListener('click', () => {
        const activeSlide = $('.active-item', gridSlider);
        const nextSlide = activeSlide.nextElementSibling;
        activeSlide.classList.remove('active-item');

        if (nextSlide) {
          scrollToSlide(listContainer, nextSlide.offsetTop - 20);
          nextSlide.classList.add('active-item');
        } else {
          scrollToSlide(listContainer, 0);
          teaserSliderItems[activeIndex].classList.add('active-item');
        }
      });
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 1199) {
        if (!isActive && teaserSliderItems.length > 1) {
          slider.init();
          isActive = true;
        }
      } else {
        if (isActive) {
          slider.destroy();
          isActive = false;
        }
      }
    });
  });
}
